import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useState } from "react";
import { RootState } from "../../../../../store/app";
import React from "react";

/**
 * Renders listing component contains the ag grid  for the Careers module.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - Information about the module.
 * @param {Function} props.handleViewClick - The click event handler for viewing the details of a record.
 * @param {Function} props.handleDeleteClick - The click event handler for deleting the details of a record.
 * @param {Function} props.handleEditClick - The click event handler for editing the details of a record.
 * @return {JSX.Element} The rendered component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const career = useAppSelector((state:RootState) => state.career);
  const [statusData, setStatusData] = useState<any>();

/**
 * Renders an ActionRenderer component for the ag grid contains the action buttons.
 *
 * @param {any} props - The props for the component.
 * @return {JSX.Element} The rendered ActionRenderer component.
 */
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        // exportParams={exportParams}
        rowData={career.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={career.perPage}
        cacheBlockSize={career.perPage}
      />
    </>
  );
};

export default Listing;
